import React, {useEffect, useRef, useState} from "react";
import styled from "styled-components";


import SocialConnectModalComponent from './SocialConnectModalComponent'
import { loginToTwitch, loginToYoutube } from "../../utils/loginHelper";
import eventBus from '../../utils/globalPubSub';

const ConnectButtonDivMobile = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: static;
  width: 66px;
  height: 32px;
  cursor: pointer;
  background: #FFFFFF;
  border-radius: 12px;
`

const ConnectButtonDivDesktop = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: static;
  width: 80px;
  height: 34px;
  cursor: pointer;
  background: #FFFFFF;
  border-radius: 12px;
`

const ConnectButtonTextSpan = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #000000;
`

const Address = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 130.5%;
  display: flex;
  align-items: center;
  text-align: center;
  color: #FFFFFF;
`;

const MobileAddress = styled.div`
  font-family: 'IBM Plex Mono';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #FFFFFF;
`

const Desktop = styled.div`
  display: none;
  background: #000;
  @media (min-device-width: 481px) {
  display: flex;
  flex-direction: column;
  /* height: 100vh; */
  height: 100%;
  /* overflow: hidden; */
  }
`;

const Mobile = styled.div`
  display: none;
  background: #000;
  @media only screen and (max-device-width: 480px) {
  display: flex;
  /* height: 96vh; */
  flex-direction: row;
  }
`;


export default function ProfileButtonComponent({
    connected, user, setShowModal}){

    const [socialConnectModalOpen,
           setSocialConnectModalOpen] = useState(false);
    
    const handleConnectTwitchClicked = ()=>{
	loginToTwitch()
    }

    const handleConnectYoutubeClicked = ()=>{
	loginToYoutube();
    }

    const checkAndSetLoginState = () => {
	let loginData = localStorage.getItem('login-details');
    }    

    const openSocialLoginDiv = () => {
        console.log('setSocialConnectModalOpen(true)')
        setSocialConnectModalOpen(true);
    }

    useEffect(()=>{
        eventBus.on("show-login-connection-modal",(data)=>{
            console.log('mfmfmfmfmfmf');
            setSocialConnectModalOpen(true);
        });
        return ()=>{
            eventBus.remove("show-login-connection-modal");
        }
    },[]);
    
    return  (
	<>
	    {connected && (
                <>
                    <Desktop>
	                <Address
		            className={'hover'}
		            onClick={() => setShowModal(true)}>
		            {user.username}
	                </Address>
                    </Desktop>
                    <Mobile>
                        <MobileAddress
		            className={'hover'}
		            onClick={() => setShowModal(true)}>
		            {user.username}
	                </MobileAddress>
                    </Mobile>
                </>
	    )}
	    {!connected && (
	        <>
                    <SocialConnectModalComponent
                        isOpen={socialConnectModalOpen}
                        setIsOpen={(val)=>{
                            setSocialConnectModalOpen(val)}}
                    >
                    </SocialConnectModalComponent>
                    <Desktop>
                        <ConnectButtonDivDesktop onClick={
                        ()=>{openSocialLoginDiv()}}>
                            <ConnectButtonTextSpan>
                                LOG IN
                            </ConnectButtonTextSpan>
                        </ConnectButtonDivDesktop>
	            </Desktop>
                    <Mobile>
                        <ConnectButtonDivMobile onClick={
                        ()=>{openSocialLoginDiv()}}>
                            <ConnectButtonTextSpan>
                                LOG IN
                            </ConnectButtonTextSpan>
                        </ConnectButtonDivMobile>
                    </Mobile>
                </>
	    )}
        </>

    );
}
